import type { RecoverFromStaleBuildOptions } from '@rammetec/app-kit/errors'

export const STALE_BUILD_OPTIONS = {
  context: {
    app: 'vectorhub-console',
    version: __APP_VERSION__,
    build: __BUILD_NUMBER__,
  },
} as const satisfies RecoverFromStaleBuildOptions
